import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { FlightLogEntity } from './flight-log.model';

export enum FlightLogActionTypes {
  LoadFlightLogs = '[FlightLog] Load FlightLogs',
  AddFlightLog = '[FlightLog] Add FlightLog',
  UpsertFlightLog = '[FlightLog] Upsert FlightLog',
  AddFlightLogs = '[FlightLog] Add FlightLogs',
  UpsertFlightLogs = '[FlightLog] Upsert FlightLogs',
  UpdateFlightLog = '[FlightLog] Update FlightLog',
  UpdateFlightLogs = '[FlightLog] Update FlightLogs',
  DeleteFlightLog = '[FlightLog] Delete FlightLog',
  DeleteFlightLogs = '[FlightLog] Delete FlightLogs',
  ClearFlightLogs = '[FlightLog] Clear FlightLogs',
  FlightLogEdited = '[FlightLog] Edited',
}
export class FlightLogEdited implements Action {
  public readonly type = FlightLogActionTypes.FlightLogEdited;
  constructor(public payload: { id: string }) {}
}
export class LoadFlightLogs implements Action {
  public readonly type = FlightLogActionTypes.LoadFlightLogs;

  constructor(public payload: { flightLogs: FlightLogEntity[] }) {}
}

export class AddFlightLog implements Action {
  public readonly type = FlightLogActionTypes.AddFlightLog;

  constructor(public payload: { flightLog: FlightLogEntity }) {}
}

export class UpsertFlightLog implements Action {
  public readonly type = FlightLogActionTypes.UpsertFlightLog;

  constructor(public payload: { flightLog: FlightLogEntity }) {}
}

export class AddFlightLogs implements Action {
  public readonly type = FlightLogActionTypes.AddFlightLogs;

  constructor(public payload: { flightLogs: FlightLogEntity[] }) {}
}

export class UpsertFlightLogs implements Action {
  public readonly type = FlightLogActionTypes.UpsertFlightLogs;

  constructor(public payload: { flightLogs: FlightLogEntity[] }) {}
}

export class UpdateFlightLog implements Action {
  public readonly type = FlightLogActionTypes.UpdateFlightLog;

  constructor(public payload: { flightLog: Update<FlightLogEntity> }) {}
}

export class UpdateFlightLogs implements Action {
  public readonly type = FlightLogActionTypes.UpdateFlightLogs;

  constructor(public payload: { flightLogs: Update<FlightLogEntity>[] }) {}
}

export class DeleteFlightLog implements Action {
  public readonly type = FlightLogActionTypes.DeleteFlightLog;

  constructor(public payload: { id: string }) {}
}

export class DeleteFlightLogs implements Action {
  public readonly type = FlightLogActionTypes.DeleteFlightLogs;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearFlightLogs implements Action {
  public readonly type = FlightLogActionTypes.ClearFlightLogs;
}

export type FlightLogActions =
  | LoadFlightLogs
  | AddFlightLog
  | UpsertFlightLog
  | AddFlightLogs
  | UpsertFlightLogs
  | UpdateFlightLog
  | UpdateFlightLogs
  | DeleteFlightLog
  | DeleteFlightLogs
  | ClearFlightLogs
  | FlightLogEdited;
